export default "__VITE_ASSET__DmH7Y96q__"